import { composerPartage } from './modeleBilan'
import { IMAGES_BILAN } from './imagesBilan'
import { mesureurCanevas, policePrete, FAMILLE } from '../Certificat/mesure'
import { nomDuFichierBilan } from './pdfBilan'

/* ⛔ L'IMAGE A PARTAGER SUR LINKEDIN, FABRIQUEE DANS LE NAVIGATEUR
   (07/10/2026, etape 2). La composition 4:5 de modeleBilan.js
   (`composerPartage`) dessinee sur un canevas de 1080 x 1350 px : les memes
   elements que le PDF et l'apercu (rect, trace, texte, image). La police
   Questrial est chargee AVANT de mesurer et de dessiner (policePrete) ; le
   crenage est coupe, comme dans la mesure et le PDF. Rien n'est envoye au
   serveur : le PNG part directement en telechargement. */

export const LARGEUR_IMAGE = 1080
export const HAUTEUR_IMAGE = 1350

const chargerImage = (src) => new Promise((ok, ko) => {
  const img = new Image()
  img.onload = () => ok(img)
  img.onerror = () => ko(new Error('bilan, image introuvable ' + src))
  img.src = src
})

/* les elements d'une composition sur un canevas, a l'echelle de sa largeur */
export const dessinerSurCanevas = async (composition, sources, canevas) => {
  const k = canevas.width / composition.page.largeur
  const ctx = canevas.getContext('2d')
  try { ctx.fontKerning = 'none' } catch (e) { /* navigateur ancien */ }
  const images = {}
  for (const el of composition.elements) {
    if (el.type === 'rect') {
      ctx.fillStyle = el.couleur
      ctx.fillRect(el.x * k, el.y * k, el.l * k, el.h * k)
    } else if (el.type === 'trace') {
      const chemin = new Path2D()
      el.boucles.forEach((b) => {
        b.forEach(([x, y], i) => (i ? chemin.lineTo(x * k, y * k) : chemin.moveTo(x * k, y * k)))
        chemin.closePath()
      })
      ctx.fillStyle = el.couleur
      ctx.fill(chemin, 'evenodd')
    } else if (el.type === 'texte') {
      ctx.save()
      ctx.fillStyle = el.couleur
      ctx.font = `400 ${el.taille * k}px ${FAMILLE}`
      ctx.textBaseline = 'alphabetic'
      ctx.translate(el.x * k, el.y * k)
      if (el.angle) ctx.rotate((-el.angle * Math.PI) / 180)
      if (el.espacement) {
        /* interlettrage : lettre par lettre (letterSpacing n'existe pas dans
           tous les Safari) */
        let x = 0
        Array.from(el.texte).forEach((ch) => {
          ctx.fillText(ch, x, 0)
          x += ctx.measureText(ch).width + el.espacement * k
        })
      } else {
        ctx.fillText(el.texte, 0, 0)
      }
      ctx.restore()
    } else if (el.type === 'image') {
      const src = sources?.[el.source]
      if (!src) continue
      if (!images[src]) images[src] = await chargerImage(src)
      ctx.drawImage(images[src], el.x * k, el.y * k, el.l * k, el.h * k)
    }
  }
  return canevas
}

export const fabriquerImagePartage = async (donnees) => {
  if (!String(donnees?.prenomNom || '').trim() || !donnees?.contenu) {
    throw new Error('bilan, nom ou contenu absent, aucune image fabriquée')
  }
  await policePrete()
  const composition = composerPartage({ ...donnees, dateDelivrance: donnees?.dateDelivrance || new Date(), mesurer: mesureurCanevas() })
  if (composition.deborde) throw new Error('bilan, l’image de partage ne tient pas, rien n’est fabriqué')
  const canevas = document.createElement('canvas')
  canevas.width = LARGEUR_IMAGE
  canevas.height = HAUTEUR_IMAGE
  await dessinerSurCanevas(composition, IMAGES_BILAN[composition.variante], canevas)
  return new Promise((ok, ko) => canevas.toBlob((b) => (b ? ok(b) : ko(new Error('bilan, image non fabriquée'))), 'image/png'))
}

export const nomDuFichierImage = (donnees) => nomDuFichierBilan(donnees).replace(/\.pdf$/, '-linkedin.png')

export const telechargerImagePartage = async (donnees) => {
  const blob = await fabriquerImagePartage(donnees)
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = nomDuFichierImage(donnees)
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(url), 10000)
  return true
}
